import { HomeSectionType } from '../enums/home-section-type.enum';

/** Home sections that list courses (the platform's services). */
export const COURSE_SECTION_TYPES: readonly HomeSectionType[] = [
  HomeSectionType.LiveCourses,
  HomeSectionType.RecordedCourses,
  HomeSectionType.OnsiteCourses,
  HomeSectionType.CompactCourses,
];

export function isCourseSection(type: HomeSectionType): boolean {
  return COURSE_SECTION_TYPES.includes(type);
}

/**
 * Unified Code criterion 7 (rows 26-28): TMS is a service platform, so the services (courses) sections
 * must come directly after the hero. In Unified mode the course sections are moved to the front, keeping
 * their relative admin order, followed by every other section in admin order. Custom mode keeps the
 * admin order untouched. Returns a new array; the input is not mutated.
 */
export function orderSectionsForMode<T extends { type: HomeSectionType }>(sequence: readonly T[], unified: boolean): T[] {
  if (!unified) return [...sequence];

  return [
    ...sequence.filter(section => isCourseSection(section.type)),
    ...sequence.filter(section => !isCourseSection(section.type)),
  ];
}
